import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDateField, DBDropDown, DBTextField } from '_components';
import styles from './Common.module.css';
import { getDateMMDDYYYY } from '_helpers';
import { WCGoalDropDown } from './WCGoalDropDown';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';

class PatientCareCenterNoteGoalsGoalDetailsWCDN extends React.Component {

    goalValueChanged() {
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    render() {
        return (
            <PatientCareCenterNoteNavAnchor id={'goal_' + this.props.goal.GONO} >
                <div className={styles.goal_detail_wrapper}>
                    <div className={styles.goal_detail_row_wc}>
                    <span className={styles.goal_detail_col1}>

                        </span>
  
                        <div className={styles.goal_detail_col2_pd_wc}>
                            <WCGoalDropDown
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                isWc={true}
                                includeCustom={false}
                                className={styles.goal_level_dropdown_wc}
                                disabled={true}
                            />
                        </div>

                         {/* PLOF */}
                         <div className={styles.goal_detail_col3_pd_wc}>
                            <DBDropDown
                                className={styles.goal_level_dropdown_wc}
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOPLOF'
                                disabled={true}
                                customOptions={this.props.goalLevels}
                            />
                        </div>
                        {/* CLOF */}
                        <div className={styles.goal_detail_col3_pd_wc}>
                            <DBDropDown
                                className={styles.goal_level_dropdown_wc}
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOCLOF'
                                disabled={true}
                                customOptions={this.props.clofGoalLevels}
                                placeholder='Current Ability'
                            />
                        </div>
                        <div className={styles.goal_detail_copy_col}>
                            
                        </div>
                        {/* GOAL */}
                        <div className={styles.goal_detail_col5_pd_wc}>
                            <DBDropDown
                                className={styles.goal_level_dropdown_wc}
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOGOALLEVEL'
                                disabled={true}
                                customOptions={this.props.goalLevels}
                            />
                        </div>
                        {/* DATE */}
                        <div className={styles.goal_detail_col6_pd_wc}>
                            <DBDateField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GODATE'
                                disabled={true}
                                customMsg='The goal date cannot be in the past.'
                                minDate={getDateMMDDYYYY(new Date())}
                            />
                        </div>
						<div className={styles.goal_detail_col7_pd_wc}>
						<DBDropDown
							className={styles.goal_level_dropdown_wc_prog}
							noteId={this.props.noteId}
							entity='PTGOALS'
							entityKeyColumn='GONO'
							entityKeyValue={this.props.goal.GONO}
							field='GOGPNO'
							masterEntity='PTMASTERGOALPROGRESS'
							masterEntityKeyColumn='GPNO'
							masterEntitySort='GPORDER'
							masterEntityDisplay='GPNAME'
							onChange={() => this.goalValueChanged()}
						/>
					</div>

                    </div>
                    <div className={styles.goal_detail_row}>
                        <div className={styles.goal_detail_col8_dn}>
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GOOBJECTIVE'
                                className={styles.text_field}
                                placeholder='Describe how the patient is performing the activity today.'
                            />
                        </div>
                    </div>
                </div>
            </PatientCareCenterNoteNavAnchor>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let goal = state.entities.notes.PTGOALS[ownprops.id];

    let clofGoalLevels = [];
    if (goal.GOMGNO) {
        // get based on XREF
        let glnos = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
            .filter(key => {
                return (state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO);
            })
            .map(key => state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO);

        clofGoalLevels = Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
            .filter(key => {
                return (glnos.includes(state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO));
            })
            .sort((a, b) => {
                let aKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[a].GLNO
                    });
                let aOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[aKey].GLXORDER;

                let bKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[b].GLNO
                    });
                let bOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[bKey].GLXORDER;

                return aOrder - bOrder;
            })
            .map(key => {
                return {
                    id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                    value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                    sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                    clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
                }
            })
    }

    let goalLevels = Object.keys(clofGoalLevels)
        .filter(key => {
            return clofGoalLevels[key].clofOnly === false;
        })
        .map(key => {
            return clofGoalLevels[key];
        });

    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;
    let activityName = goal.GOMGNO ? state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : '';

    let isLiftPush = activityName.toLowerCase().startsWith('lift/carry') || activityName.toLowerCase().startsWith('push/pull') ? true : false;

    return {
        noteId,
        noteType,
        pk,
        goal,
        clofGoalLevels,
        goalLevels,
        goalsUpdated,
        isLiftPush,
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsWCDN = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalDetailsWCDN);
export { connectedPatientCareCenterNoteGoalsGoalDetailsWCDN as PatientCareCenterNoteGoalsGoalDetailsWCDN };

